import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_centerX() {
  return (this.tdg() + this.vdg()) / 2;
}
function get_centerY() {
  return (this.udg() + this.wdg()) / 2;
}
var RecyclerViewPlaceableClass;
function RecyclerViewPlaceable() {
  if (RecyclerViewPlaceableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewPlaceable');
    RecyclerViewPlaceableClass = $;
  }
  return RecyclerViewPlaceableClass;
}
//region block: exports
export {
  get_centerX as get_centerX2in8u6xgwmvfr,
  get_centerY as get_centerY2o32deip08ur4,
  RecyclerViewPlaceable as RecyclerViewPlaceable30p36x6wixz5i,
};
//endregion

//# sourceMappingURL=RecyclerViewPlaceable.mjs.map
